import { render, staticRenderFns } from "./arrangeFooter.vue?vue&type=template&id=3a4b919f&scoped=true&"
import script from "./arrangeFooter.vue?vue&type=script&lang=js&"
export * from "./arrangeFooter.vue?vue&type=script&lang=js&"
import style0 from "./arrangeFooter.vue?vue&type=style&index=0&id=3a4b919f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4b919f",
  null
  
)

export default component.exports